import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/star/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-42c8efdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "star-dialog-mask"
}
const _hoisted_2 = { class: "star-dialog" }
const _hoisted_3 = { class: "star-dialog-header" }
const _hoisted_4 = { class: "star-dialog-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "star-dialog-logo"
}, null, -1))
const _hoisted_6 = { class: "star-dialog-body" }
const _hoisted_7 = { class: "star-dialog-content" }
const _hoisted_8 = { class: "star-dialog-footer" }
const _hoisted_9 = { class: "star-dialog" }
const _hoisted_10 = { class: "star-dialog-header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "star-dialog-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "star-dialog-logo"
  }),
  /*#__PURE__*/_createTextVNode(" 立即解锁 ")
], -1))
const _hoisted_12 = { class: "star-dialog-body" }
const _hoisted_13 = { class: "star-qr-wrap" }
const _hoisted_14 = {
  ref: "qrContainerRef",
  style: {"width":"160px","height":"160px"}
}
const _hoisted_15 = { class: "star-dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.tipDialog.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.tipDialog.title), 1)
              ]),
              _createElementVNode("span", {
                class: "star-dialog-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tipDialog.visible = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.tipDialog.content), 1),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.tipDialog.showCancel)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "star-btn-cancel",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tipDialog.visible = false))
                    }, "取消"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "star-btn-confirm",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.tipDialog.onConfirm && _ctx.tipDialog.onConfirm(...args)))
                }, _toDisplayString(_ctx.tipDialog.confirmText), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showQrDialog)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "star-dialog-mask",
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('update:showQrDialog', false)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", {
                class: "star-dialog-close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:showQrDialog', false)))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, null, 512)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "star-btn-confirm",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:showQrDialog', false)))
                }, "关闭")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}